<template>
  <div class="etc-qa">
    <section class="search-box">
      <div class="search-wrap">
        <i class="iconfont etc-icon-search"></i>
        <input type="text" v-model="search"
               @input="handleSearch"
               placeholder="请输入关键字查询相关信息">
        <i class="iconfont etc-icon-cha" :class="{'v-hidden': !search}" @click="clearSearch"></i>
      </div>
    </section>
    <section class="search-result" v-show="search">
      <div class="search-qa" v-for="(item, index) in searchQA" :key="index">
        <header :class="item.open?'':'close'" @click="clickSearch(index)">
          <strong>{{item.title}}</strong>
          <i class="iconfont" :class="item.open?'etc-icon-arrow-up':'etc-icon-arrow-down'"></i>
        </header>
        <div class="qa-content" v-html="item.content" v-show="item.open"></div>
      </div>
      <div class="no-data" v-if="!searchQA.length">未找到相关内容</div>
    </section>
    <section class="qa-box" v-show="!search">
      <img class="qa-top-bg" src="../../assets/some/qa-top.png" alt="">
      <div class="related-qa">
        <header class="qa-header">
          <span>相关问题</span>
        </header>
        <template v-if="relatedQAs.length">
          <div class="related-qa-wrap" v-for="(item, index) in relatedQAs" :key="index">
            <div class="qa-title" :class="item.open?'':'close'" @click="clickRelate(index)">
              <strong>{{item.title}}</strong>
              <i class="iconfont" :class="item.open?'etc-icon-arrow-up':'etc-icon-arrow-down'"></i>
            </div>
            <div class="qa-content" v-if="item.open" v-html="item.content"></div>
          </div>
        </template>
        <div class="no-data" v-else>{{requestEnd?'暂无数据':''}}</div>
      </div>
      <div class="more-qa">
        <header class="qa-header">
          <span>更多问题</span>
        </header>
        <template v-if="moreQAs.length">
          <div class="more-qa-wrap" v-for="(item, index) in moreQAs" :key="index">
            <div class="qa-img" @click="clickMoreImg(index)">
              <img :src="item.category_icon | transHTTP" alt="">
              <p>{{item.category_name}}</p>
              <i class="iconfont" :class="item.open?'etc-icon-arrow-up':'etc-icon-arrow-down'" v-if="item.list.length>2"></i>
            </div>
            <ul class="qa-list">
              <template v-for="(li, index2) in item.list">
                <li :key="index2" v-if="item.open || index2 < 2" @click="clickMoreQA(index, index2)">
                  {{li.title}}
                </li>
              </template>
            </ul>
          </div>
        </template>
        <div class="no-data" v-else>{{requestEnd?'暂无数据':''}}</div>
      </div>
    </section>
    <section class="search-bottom">
      <!--<p>审核及物流问题咨询QQ 478558480</p>-->
      <!--<p>安装激活问题咨询QQ 730621695</p>-->
      <!--<p>其他问题咨询QQ 430039195</p>-->
      <a href="tel:4008538068">客服电话 4008538068</a>
      <p>工作时间：9:00-21:00</p>
    </section>
    <modal ref="modal">
      <div slot="content" class="qa-modal">
        <header><strong>{{chooseQA.title}}</strong><i class="iconfont etc-icon-close" @click="closeModal"></i></header>
        <div class="qa-content" v-html="chooseQA.content"></div>
      </div>
    </modal>
  </div>
</template>

<script>
// api
import SystemApi from '@/api/system.api'
// config
import ETC from '@/config/etc.config'
// mixins
import FunMixin from '@/mixins/funMixin'
// store
import {mapState} from 'vuex'
// components
import Modal from '@/components/cool.modal'
// clip
import ClipboardJS from 'clipboard/dist/clipboard.min'

const MODAL_CONFIG = {contentSlot: true, defaultFooter: false}

let clipboard = new ClipboardJS('.copy-btn');

clipboard.on('success', function(e) {
  console.info('clipboard success:', e.action, e.text);
  // console.info('Trigger:', e.trigger);

  e.clearSelection();
});

clipboard.on('error', function(e) {
  console.error('clipboard error:', e);
});

export default {
  name: 'qa',
  mixins: [FunMixin],
  components: {
    Modal
  },
  data() {
    return {
      search: '',
      relatedQAs: [],
      moreQAs: [],
      searchQA: [],
      chooseQA: {},
      requestEnd: false
    }
  },
  computed: {
    ...mapState([
      'currentCard'
    ])
  },
  methods: {
    handleSearch() {
      if (this.search) {
        let searchs = this.search.toUpperCase()
        // 遍历当前前端文本
        let q = this.relatedQAs ? this.relatedQAs.filter(item => {
          let { title, content } = item
          if (title.toUpperCase().indexOf(searchs) > -1 || content.toUpperCase().indexOf(searchs) > -1) return item
        }) : []
        // 更多问题
        this.moreQAs && this.moreQAs.map(item => {
          const { list } = item
          list.forEach(l => {
            const { title, content } = l
            if (title.toUpperCase().indexOf(searchs) > -1 || content.toUpperCase().indexOf(searchs) > -1) {
              q.push(l)
            }
          })
        })
        q.forEach(item => (item.open = true))
        this.searchQA = q
      } else {
        this.searchQA = []
      }
    },
    clearSearch() {
      this.search = ''
      this.searchQA = []
    },
    closeModal() {
      this.$refs.modal.$emit('hideModal')
      this.m_scroll(true)
    },
    clickMoreQA(i, j) {
      this.chooseQA = this.moreQAs[i].list[j]
      this.$refs.modal.$emit('showModal', MODAL_CONFIG)
      this.m_scroll(false)
    },
    clickSearch(i) {
      this.searchQA[i].open = !this.searchQA[i].open
      this.$set(this.searchQA, i, this.searchQA[i])
    },
    clickRelate(index) {
      this.relatedQAs[index].open = !this.relatedQAs[index].open
      this.$set(this.relatedQAs, index, this.relatedQAs[index])
    },
    clickMoreImg(index) {
      this.moreQAs[index].open = !this.moreQAs[index].open
      this.$set(this.moreQAs, index, this.moreQAs[index])
    }
  },
  async mounted() {
    // 获取配置参数
    this.m_showLoading()
    try {
      let {page_id, card_id = this.currentCard.card_id || this.currentCard.id || '0'} = ETC.QA_PAGE_IDS[this.$route.query.fromPage]
      // 请求数据
      const {relatedQuestions, moreQuestions} = await SystemApi.getQA({page_id, card_id})
      this.relatedQAs = relatedQuestions || []
      this.moreQAs = moreQuestions || []
      if (this.relatedQAs.length) this.relatedQAs[0].open = true
      this.requestEnd = true
      // 若有 qaId 默认弹窗显示
      if (this.$route.query.qaId && this.moreQAs.length) {
        for (let i in this.moreQAs) {
          let l = this.moreQAs[i].list.filter(l => l.id === this.qaId)
          if (l.length) this.chooseQA = l[0]
          break
        }
        if (this.chooseQA.id) {
          this.$refs.modal.$emit('showModal', MODAL_CONFIG)
          this.m_scroll(false)
        }
      }
    } finally {
      this.m_loadingClose()
    }
  },
  async created () {
  }
}
</script>

<style lang="scss">
@import "../../style/cool.practical";
.etc-qa{
  background-color: $page-bg-c;
  .search-box{
    background-color: #001d2c;
    width: 100%;
    padding: 20px 35px;
    .search-wrap{
      border-radius: 10px;
      height: 50px;
      @extend %flex-space-between;
      background-color: #FFFFFF;
      i{
        font-size: 24px;
        color: #999999;
      }
      .etc-icon-search{
        margin: 2px 10px 0 20px;
      }
      .etc-icon-cha{
        margin: 2px 20px 0 10px;
      }
      input{
        flex: 1;
        height: 50px;
        line-height: 50px;
        font-size: 26px;
        color: #333333;
        @include placeholder(0, 26px)
      }
    }
  }
  .qa-content{
    font-size: 26px;
    color: #666666;
    line-height: 46px;
  }
  .search-result{
    background-color: #fff;
    padding-left: 40px;
    .search-qa{
      header{
        height: 90px;
        line-height: 90px;
        font-size: 30px;
        color: #333333;
        border-bottom: 1px solid $border-bottom-color;
        @extend %flex-space-between;
        i{
          color: #666666;
          margin-right: 40px;
        }
      }
      .qa-content{
        padding: 40px 40px 40px 0;
      }
      &:last-child{
        .close{
          border-bottom: none;
        }
      }
    }
  }
  .qa-box{
    .qa-top-bg{
      width: 100%;
    }
    .qa-header{
      font-size: 28px;
      color: #999999;
      height: 80px;
      line-height: 80px;
      padding-left: 40px;
      border-bottom: 1px solid $border-bottom-color;
      span{
        padding-left: 20px;
        @include title-before(2px, 30px);
      }
    }
    .related-qa{
      background-color: #fff;
      margin-bottom: 20px;
      .related-qa-wrap{
        padding-left: 40px;
        .qa-title{
          font-size: 30px;
          color: #333333;
          height: 90px;
          line-height: 90px;
          padding-right: 40px;
          border-bottom: 1px solid $border-bottom-color;
          box-sizing: content-box;
          @extend %flex-space-between;
          i{
            color: #999999;
          }
        }
        .qa-content{
          padding: 20px 40px 20px 0;
          border-bottom: 1px solid $border-bottom-color;
        }
        &:last-child{
          .qa-title.close{
            border-bottom: none;
          }
          .qa-content {
            border-bottom: none;
          }
        }
      }
    }
    .more-qa{
      background-color: #FFFFFF;
      .more-qa-wrap{
        border-bottom: 1px solid $border-bottom-color;
        @extend %flex-space-between;
        .qa-img{
          font-size: 28px;
          width: 216px;
          flex-basis: 216px;
          text-align: center;
          //@extend %flex-center-column;
          img{
            width: 74px;
            height: 74px;
          }
          p{
            color: #333333;
            margin-top: -10px;
          }
          i{
            color: #999999;
          }
        }
        .qa-list{
          flex: 1;
          padding-left: 40px;
          position: relative;
          li{
            height: 90px;
            line-height: 90px;
            font-size: 26px;
            color: #666666;
            border-bottom: 1px solid $border-bottom-color;
            &:last-child{
              border-bottom: none;
            }
          }
          &:before{
            content: '';
            position: absolute;
            height: 70%;
            width: 1px;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            background-color: $border-bottom-color;
          }
        }
        &:last-child{
          border-bottom: none;
        }
      }
    }
  }
  .search-bottom{
    text-align: center;
    font-size: 26px;
    color: #666666;
    padding: 30px 0;
    line-height: 48px;
    a{
      color: #666666;
      text-decoration: none;
    }
  }
  .qa-modal{
    background-color: #fff;
    header{
      height: 90px;
      line-height: 90px;
      padding: 0 40px;
      border-bottom: 1px solid $border-bottom-color;
      font-size: 30px;
      color: #333333;
      @extend %flex-space-between;
      i{
        color: #666666;
        font-size: 28px;
      }
    }
    .qa-content{
      padding: 40px;
      max-height: 70vh;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }
  }
  .no-data{
    text-align: center;
    font-size: 28px;
    color: #999;
    height: 90px;
    line-height: 90px;
  }
}
</style>
